// extracted by css-extract-rspack-plugin
export default {"customVizListItem":"QDa9L","menuContainer":"d9PiT"};